const _ = require('lodash');

function PartnerService(restangular) {
    this._api = restangular.one('partners');
}

PartnerService.prototype.getPartner = _.memoize(function (id) {
    return this._api.one(id).get();
});

PartnerService.prototype.getBranch = _.memoize(function (id) {
    return this._api.one('branches', id).get();
});

module.exports = PartnerService;



// WEBPACK FOOTER //
// ./src/shop/partner/partner.service.js